import { render, staticRenderFns } from "./approval-process-detail.vue?vue&type=template&id=bed38ca8&scoped=true"
import script from "./approval-process-detail.vue?vue&type=script&lang=js"
export * from "./approval-process-detail.vue?vue&type=script&lang=js"
import style0 from "./approval-process-detail.vue?vue&type=style&index=0&id=bed38ca8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed38ca8",
  null
  
)

export default component.exports